import { render, staticRenderFns } from "./CouponPendingList.vue?vue&type=template&id=615678c8&scoped=true"
import script from "./CouponPendingList.vue?vue&type=script&lang=js"
export * from "./CouponPendingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615678c8",
  null
  
)

export default component.exports